import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { MainState } from './state';

const defaultState: MainState = {
  isLoggedIn: null,
  token: '',
  logInError: false,
  userProfile: null,
  dashboardMiniDrawer: false,
  dashboardShowDrawer: true,
  notifications: [],
  mainMenu: [],
  dropdownMenu: [],
  structureResponse: {
    count: 0,
    next: 0,
    previous: 0,
    current: 0,
    results: [],
    columns: [],
    tags_groups_columns: [],
    total_count: 0,
    total_donations_current: 0,
    total_donations_prev: 0,
  },
  waitingUsersResponse: {
    count: 0,
    next: 0,
    previous: 0,
    current: 0,
    results: [],
    total_count: 0,
  },
  actionLogsResponse: {
    count: 0,
    next: 0,
    previous: 0,
    current: 0,
    results: [],
    total_count: 0,
  },
  structureUserDetails: null,
  appConfigs: {},
};

export const mainModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
